<template>
    <div id="sidebar">
        <div class="inner">
            <div class="tt" :style="{ 'pointer-events': $route.path == '/' ? 'none' : 'all' }">
                <router-link to="/">
                    <TtVertical/>
                </router-link>
            </div>
            <MainNav />
        </div>
    </div>
</template>

<script>
    import MainNav from '@/components/framework/sub/MainNav'
    import TtVertical from '@/components/svgs/TtVertical'
    export default {
        name: "SidebarBlock",
        components: {
            MainNav,
            TtVertical
        },
    }
</script>
